/**
 * Converts an error code to a corresponding pattern based on a provided pattern map.
 *
 * @param {string|number} errorCode - The error code to be converted.
 * @param {Object} patternMap - An object containing patterns as keys and their associated values.
 * @returns {string} - The converted error pattern or an empty string if no match is found.
 */
export const convertErrorToken = (errorCode, patternMap) => {
  // Convert the error code to a string for consistent processing.
  const errorCodeStr = errorCode.toString()
  // Iterate through each pattern key in the pattern map.
  for (const pattern in patternMap) {
    // Skip the 'default' pattern as it serves as a fallback.
    if (pattern === 'default') continue
    // Split the pattern key into individual sub-patterns separated by '|'.
    const subPatterns = pattern.split('|')
    // Process each sub-pattern to create a regular expression for matching.
    for (const subPattern of subPatterns) {
      // Replace 'x' with '\\d' to match any digit and 'x' to represent a literal 'x'.
      const regexPattern = subPattern.replace(/x/g, '\\d').replace(/x/g, 'x')
      // Create a regular expression from the processed sub-pattern.
      const regex = new RegExp(`^(${regexPattern})`)
      // Attempt to match the error code against the regular expression.
      if (errorCodeStr.match(regex)) {
        // If a match is found, replace '*' with 'x' in the sub-pattern to get the converted error code.
        return subPattern.replace(/x/g, 'x')
      }
    }
  }
  // Return an empty string if no matching pattern is found.
  return ''
}
